module.exports = __webpack_public_path__ + "img/Peritécios, Ascas e Ascósporos 1.38a5915b.webp";